// extracted by mini-css-extract-plugin
export var previewDisplaySCLCategories = "uiebQ";
export var previewDisplaySCLCategoriesTwoLine = "hdmNJ";
export var previewDisplaySCLCategoryWellFloat = "aNZlB";
export var priorityIconAlignTop = "ZPgri";
export var reactionsAlignSecondRow = "uhhGi";
export var threeColFolderTag = "d8RVr";